import classNames from 'classnames';
import useWorldTheme from 'hooks/shared/useWorldTheme';
import type { FC } from 'react';
import type { color } from 'types/shared/worlds';

const themeColors: Record<string, string> = {
  revenues: 'text-revenues-600',
  expenses: 'text-expenses-600',
  taxes: 'text-taxes-600',
  bank: 'text-bank-600',
  primary: 'text-primary-600',
};

const LoadingSpinner: FC<{
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  color?: color | 'primary';
}> = ({ className, size = 'md', color }) => {
  const _color = useWorldTheme();
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
  };

  const colorClass = themeColors[color || _color] || themeColors.primary;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(
        'animate-spin',
        sizeClasses[size],
        colorClass,
        className,
      )}
    >
      <path
        d="M20 12L16.25 12M7.75 12H4M12 20V16.25M12 7.75V4M6.343 17.656L8.994 15.004M15.004 8.993L17.655 6.341M6.341 6.34L8.992 8.991M14.997 14.996L17.653 17.652"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default LoadingSpinner;
